import React from "react";
import PropTypes from "prop-types";
import { FiExternalLink as FiExternalLinkIcon } from "react-icons/fi";
import { IoIosArrowRoundBack as IoIosArrowRoundBackIcon } from "react-icons/io";

import { ButtonLinkStyled } from "../../common/Buttons/Button.Style";

import { ReactComponent as ANSLogo } from "../../../assets/images/icons/agencia-nacional-saude-suplementar-icon.svg";

import * as S from "./PQOResultsSection.style";

const PQOResultsList = [
  {
    id: 1,
    title: "2024",
    listLabels: [
      "IDSS OPERADORA 2023 – ANO BASE 2022: 0,6201",
      "IDQS – Qualidade em Atenção à Saúde: 0,0000",
      "IDGA – Garantia de Acesso: 0,0000",
      "IDSM – Sustentabilidade no Mercado: 0,8361",
      "IDGR – Gestão de Processos e Regulação: 0,4841",
    ],
    href:
      "https://www.ans.gov.br/qualificacao_consumidor/informacoes_operadora.asp?co_operadora_param=418072&cd_processamento_param=20240101#consulta_idss",
  },
  {
    id: 2,
    title: "2023",
    listLabels: [
      "IDSS OPERADORA 2023 – ANO BASE 2022: 0,6201",
      "IDQS – Qualidade em Atenção à Saúde: 0,4626",
      "IDGA – Garantia de Acesso: 0,5149",
      "IDSM – Sustentabilidade no Mercado: 0,8333",
      "IDGR – Gestão de Processos e Regulação: 0,7687",
    ],
    href:
      "https://www.ans.gov.br/qualificacao_consumidor/informacoes_operadora.asp?co_operadora_param=418072&cd_processamento_param=20230102#consulta_idss",
  },
  {
    id: 3,
    title: "2022",
    listLabels: [
      "IDSS 2022 – Ano Base 2021:0,4574",
      "IDQS – Qualidade em Atenção à Saúde: 0,5367",
      "IDGA – Garantia de Acesso: 0,5138",
      "IDSM – Sustentabilidade no Mercado: 0,3333",
      "IDGR – Gestão de Processos e Regulação: 0,4220",
    ],
    href:
      "https://www.gov.br/ans/pt-br/assuntos/informacoes-e-avaliacoes-de-operadoras/qualificacao-ans",
  },
  {
    id: 4,
    title: "2021",
    listLabels: [
      "IDSS 2021 – Ano Base 2020: 0,6142",
      "IDQS – Qualidade em Atenção à Saúde: 0,4382",
      "IDGA – Garantia de Acesso: 0,5164",
      "IDSM – Sustentabilidade no Mercado: 0,8208",
      "IDGR – Gestão de Processos e Regulação: 0,8162",
    ],
    href:
      "https://www.ans.gov.br/qualificacao_consumidor/informacoes_operadora.asp?co_operadora_param=418072&cd_processamento_param=20210101#consulta_idss",
  },
  {
    id: 5,
    title: "2020",
    listLabels: [
      "IDSS 2020 – Ano Base 2019: 0,6281",
      "IDQS – Qualidade em Atenção à Saúde: 0,5094",
      "IDGA – Garantia de Acesso: 0,5894",
      "IDSM – Sustentabilidade no Mercado: 0,8333",
      "IDGR – Gestão de Processos e Regulação: 0,4849",
    ],
    href:
      "https://www.ans.gov.br/qualificacao_consumidor/informacoes_operadora.asp?co_operadora_param=418072&cd_processamento_param=20200101#consulta_idss",
  },
  {
    id: 6,
    title: "2019",
    listLabels: [
      "IDSS 2019 – Ano Base 2018: 0,5649",
      "IDQS – Qualidade em Atenção à Saúde: 0,3429",
      "IDGA – Garantia de Acesso: 0,4199",
      "IDSM – Sustentabilidade no Mercado: 0,8571",
      "IDGR – Gestão de Processos e Regulação: 0,7891",
    ],
    href:
      "https://www.ans.gov.br/planos-de-saude-e-operadoras/informacoes-e-avaliacoes-de-operadoras/qualificacao-ans",
  },
  {
    id: 7,
    title: "2018",
    listLabels: [
      "IDSS 2018 – Ano Base 2017: 0,4130",
      "IDQS – Qualidade em Atenção à Saúde: 0,1621",
      "IDGA – Garantia de Acesso: 0,2609",
      "IDSM – Sustentabilidade no Mercado: 0,6857",
      "IDGR – Gestão de Processos e Regulação: 0,8045",
    ],
    href:
      "https://www.ans.gov.br/perfil-do-setor/dados-e-indicadores-do-setor/dados-do-programa-de-qualificacao-de-operadoras",
  },
];

const PQOResultsSection = ({ goBackHref }) => {
  return (
    <S.PQOResultsSectionContainer id="results">
      <S.PQOResultsSectionContent className="container">
        <ButtonLinkStyled as="a" href={goBackHref}>
          <IoIosArrowRoundBackIcon size={28} />
          Voltar
        </ButtonLinkStyled>

        <S.PQOResultsSectionHeader>
          <S.PQOResultsSectionTitle>
            Programa de Qualificação de Operadoras - PQO
          </S.PQOResultsSectionTitle>

          <S.PQOResultsSectionDescription>
            Iniciativa desenvolvida pela Agência Nacional de Saúde Suplementar
            (ANS) para avalição anual do desempenho das operadoras de planos de
            saúde. Os resultados da avaliação das operadoras são traduzidos pelo
            Índice de Desempenho da Saúde Suplementar (IDSS). O IDSS é um índice
            composto por um conjunto de indicadores agrupados em quatro
            dimensões, que é calculado com base nos dados extraídos dos sistemas
            de informações da Agência ou coletados nos sistemas nacionais de
            informação em saúde.
          </S.PQOResultsSectionDescription>

          <S.PQOResultsSectionDescription>
            Confira os resultados da Caixa Seguradora Especializada em Saúde S/A
            (Reg. ANS 41807-2)
          </S.PQOResultsSectionDescription>
        </S.PQOResultsSectionHeader>

        <S.PQOResultsSectionList>
          {PQOResultsList.map((PQOResultItem) => (
            <S.PQOResultsSectionItem key={PQOResultItem.id}>
              <S.PQOResultsSectionItemTitle>
                {PQOResultItem.title}
              </S.PQOResultsSectionItemTitle>

              <S.PQOResultsSectionItemContent>
                {PQOResultItem.listLabels.map((currentLabel) => (
                  <S.PQOResultsSectionDescription
                    key={`${PQOResultItem.title}+${currentLabel}`}
                  >
                    {currentLabel}
                  </S.PQOResultsSectionDescription>
                ))}
              </S.PQOResultsSectionItemContent>

              <ButtonLinkStyled
                as="a"
                href={PQOResultItem.href}
                target="_blank"
              >
                <FiExternalLinkIcon size={24} />
                <span>{PQOResultItem.href}</span>
              </ButtonLinkStyled>
            </S.PQOResultsSectionItem>
          ))}
        </S.PQOResultsSectionList>

        <S.PQOResultsSectionFooter>
          <ANSLogo />
        </S.PQOResultsSectionFooter>

        <ButtonLinkStyled as="a" href={goBackHref}>
          <IoIosArrowRoundBackIcon size={28} />
          Voltar
        </ButtonLinkStyled>
      </S.PQOResultsSectionContent>
    </S.PQOResultsSectionContainer>
  );
};

PQOResultsSection.propTypes = {
  goBackHref: PropTypes.string.isRequired,
};

PQOResultsSection.defaultProps = {};

export default PQOResultsSection;
